"use strict";
/**
 * @description 创建table
 * @author lichunlin
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PanelMenu_1 = __importDefault(require("../menu-constructors/PanelMenu"));
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var create_panel_conf_1 = __importDefault(require("./create-panel-conf"));
var Panel_1 = __importDefault(require("../menu-constructors/Panel"));
var index_1 = __importDefault(require("./bind-event/index"));
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(editor) {
        var _this = this;
        var $elem = dom_core_1.default('<div class="w-e-menu"><i class="w-e-icon-table2"></i></div>');
        _this = _super.call(this, $elem, editor) || this;
        // 绑定事件
        index_1.default(editor);
        return _this;
    }
    /**
     * 菜单点击事件
     */
    Table.prototype.clickHandler = function () {
        this.createPanel();
    };
    /**
     * 创建 panel
     */
    Table.prototype.createPanel = function () {
        var conf = create_panel_conf_1.default(this.editor);
        var panel = new Panel_1.default(this, conf);
        panel.create();
    };
    /**
     * 尝试修改菜单 active 状态
     */
    Table.prototype.tryChangeActive = function () { };
    return Table;
}(PanelMenu_1.default));
exports.default = Table;
